const DOCUMENT_AUDIT_CATEGORY_LABELS: Record<string, string> = {
  Document: 'Documento',
  Structural: 'Estrutural',
  Relationship: 'Relacionamento',
  Access: 'Acesso',
  Signature: 'Assinatura',
  Workflow: 'Workflow',
};

const DOCUMENT_AUDIT_ACTION_LABELS: Record<string, string> = {
  Create: 'Documento criado',
  NewVersion: 'Nova versão',
  Edit: 'Documento editado',
  Delete: 'Documento excluído',
  Publish: 'Versão publicada',
  Revert: 'Versão restaurada',
  LifecycleScheduleUpdated: 'Agendamento de ciclo de vida atualizado',
  ArchivePublishedWithoutActiveWorkflow: 'Arquivado sem workflow ativo',
  Move: 'Documento movido',
  Rename: 'Documento renomeado',
  Duplicate: 'Documento duplicado',
  PermissionChanged: 'Permissões alteradas',
  RelationAdded: 'Relacionamento adicionado',
  RelationRemoved: 'Relacionamento removido',
  View: 'Visualização',
  Download: 'Download',
  PublicLinkAccess: 'Acesso por link público',
  RequestCreated: 'Solicitação de assinatura criada',
  InvitesSent: 'Convites enviados aos signatários',
  Signed: 'Assinatura registrada',
  Completed: 'Todas as assinaturas concluídas',
  Rejected: 'Assinatura recusada',
  Cancelled: 'Solicitação de assinatura cancelada',
  AccessAttemptSucceeded: 'Acesso ao convite validado',
  AccessAttemptFailed: 'Tentativa de acesso ao convite falhou',
};

export function documentAuditCategoryLabel(category: string): string {
  return DOCUMENT_AUDIT_CATEGORY_LABELS[category] ?? category;
}

export function documentAuditActionLabel(actionName: string): string {
  return DOCUMENT_AUDIT_ACTION_LABELS[actionName] ?? actionName;
}

const SIGNATURE_AUDIT_ACTIONS = new Set([
  'RequestCreated',
  'InvitesSent',
  'Signed',
  'Completed',
  'Rejected',
  'Cancelled',
  'AccessAttemptSucceeded',
  'AccessAttemptFailed',
]);

export function isSignatureDocumentAuditAction(actionName: string): boolean {
  return SIGNATURE_AUDIT_ACTIONS.has(actionName);
}

export function getDocumentAuditActionFriendlyLabel(actionName: string): string | undefined {
  return DOCUMENT_AUDIT_ACTION_LABELS[actionName];
}
